module.exports = __webpack_public_path__ + "c922d0af5e319780cff6fa2058dba522.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1_variable/public/news/img1_2.jpg
// module id = 441
// module chunks = 0